import { render, staticRenderFns } from "./AddUpdateModal.vue?vue&type=template&id=0de7879e&scoped=true&"
import script from "./AddUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./AddUpdateModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddUpdateModal.vue?vue&type=style&index=0&id=0de7879e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de7879e",
  null
  
)

export default component.exports